import React from "react";

import { NavLink } from "react-router-dom";

import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";

import "./Footer.scss";
import { AppBar } from "@mui/material";

const paths = [
  { title: "Dashboard", url: "/" },
  { title: "Customers", url: "customers" },
  { title: "Completed", url: "completed" },
];

function Footer() {
  return (
    <AppBar
      position="fixed"
      className="bg-warning"
      sx={{ bottom: 0, top: "auto" }}
    >
      <Toolbar className="footer-nav ">
        {paths.map((path, key) => {
          return (
            <Button color="inherit" key={key}>
              <NavLink
                to={path.url}
                className={({ isActive }) =>
                  isActive ? "footer-nav--active" : "footer-nav--link"
                }
              >
                {path.title}
              </NavLink>
            </Button>
          );
        })}
      </Toolbar>
    </AppBar>
  );
}

export default Footer;
